<template>
  <!-- eslint-disable vue/no-v-model-argument -->
  <WdsPageSignup class="wds-page-signup-login" nav-prev @prev="back">
    <template #left>
      <LeftWelcome />
    </template>

    <template #nav-right>
      <AuthLanguageSwitcher />
    </template>

    <template #right>
      <WdsHeading as="h1" type="title1">
        {{ $t('Reset your password') }}
      </WdsHeading>

      <BaseHtmlForm action="/reset-password" method="POST" class="tw-mt-8">
        <input hidden name="token" :value="token" />

        <WdsInput
          lg
          name="email"
          type="email"
          :model-value="email"
          readonly
          data-test="reset-password-email-input"
        >
          <template #label>
            {{ $t('Email') }}
          </template>
        </WdsInput>

        <div class="tw-mt-4">
          <WdsInput
            v-model="password"
            lg
            name="password"
            type="password"
            required
            autofocus
            :error="errors.length === 0 ? undefined : errors.join('\n')"
            data-test="reset-password-password-input"
          >
            <template #label>
              {{ $t('Password') }}
            </template>
          </WdsInput>
        </div>

        <div class="tw-mt-4">
          <WdsInput
            v-model="confirmPassword"
            lg
            name="password_confirmation"
            type="password"
            required
            data-test="reset-password-password-confirmation-input"
          >
            <template #label>
              {{ $t('Confirm Password') }}
            </template>
          </WdsInput>
        </div>

        <div class="tw-text-center tw-mt-6">
          <WdsButton
            lg
            primary
            full-width
            :disabled="!identicalPassword"
            data-test="reset-password-reset-password-button"
          >
            {{ $t('Reset password') }}
          </WdsButton>
        </div>
      </BaseHtmlForm>
    </template>
  </WdsPageSignup>
</template>

<script lang="ts">
import { WdsButton, WdsHeading, WdsInput, WdsPageSignup } from '@worksome/wds-components'
import BaseHtmlForm from '@/components/BaseHtmlForm.vue'
import AuthLanguageSwitcher from '@/components/auth/AuthLanguageSwitcher.vue'
import LeftWelcome from '@/components/auth/left/LeftWelcome.vue'
import { $t } from '@/composables/translation'

export default {
  name: 'ResetPasswordPage',
  components: {
    BaseHtmlForm,
    AuthLanguageSwitcher,
    LeftWelcome,
    WdsButton,
    WdsHeading,
    WdsInput,
    WdsPageSignup,
  },
  props: {
    errors: {
      type: Array,
      default: [],
    },
    email: {
      type: String,
      required: true,
    },
    token: {
      type: String,
      required: true,
    },
  },
  setup() {
    function back() {
      window.location.href = `${window.location.protocol}//${window.location.host}/login`
    }

    return {
      back,
      $t,
    }
  },
  data() {
    return {
      csrf: document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? '',
      password: '',
      confirmPassword: '',
    }
  },
  computed: {
    identicalPassword() {
      return this.confirmPassword === this.password && this.password !== ''
    },
  },
}
</script>

<style scoped lang="scss"></style>
